import { ChangeEvent, FC, useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Grid, Paper, Tab, Tabs } from '@material-ui/core';
import { useStylesSecond } from './styles';
import TabPanel from 'components/TabPanel';
import { InviteTable } from './InviteTable';
import { Badge } from '@mui/material';

export const TabsShowRequest: FC = observer(() => {
  const classes = useStylesSecond();
  function a11yProps(index: string) {
    return {
      id: `wrapped-tab-${index}`,
      'aria-controls': `wrapped-tabpanel-${index}`,
    };
  }

  const [value, setValue] = useState<string>('one');
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleChange = (event: ChangeEvent<unknown>, newValue: string) => {
    setValue(newValue);
  };

  useEffect(() => {
    document.title = 'EasyIdentity: Reports: Admin Users';
  }, []);

  return (
    <Grid item xl className={classes.tabsPanel}>
      <Paper className={classes.tabsPaper}>
        <Tabs
          value={value}
          className={classes.tabs}
          TabIndicatorProps={{ style: { color: 'transparent', background: 'transparent' } }}
          onChange={handleChange}>
          <Tab
            value='one'
            wrapped
            label={
              <Badge color='error'>
                <span> Account Update</span>
              </Badge>
            }
            {...a11yProps('one')}
            className={classes.label}
          />
          <Tab
            value='two'
            wrapped
            label={
              <Badge color='error'>
                <span> Password Update</span>
              </Badge>
            }
            {...a11yProps('two')}
            className={classes.label}
          />
        </Tabs>

        <div className={classes.tabBox}>
          <TabPanel value={value} index='one'>
            <InviteTable newRequests />
          </TabPanel>
          <TabPanel value={value} index='two'>
            <InviteTable />
          </TabPanel>
        </div>
      </Paper>
    </Grid>
  );
});
